import { TooltipProps } from "@mui/material"
import InfoIcon from "components/icons/other/info"
import { TooltipIcon, TooltipStyled } from "./styled"

type Props = {
  title?: string
} & Partial<TooltipProps>

const Tooltip = ({ title, ...otherProps }: Props) => {

  if (!title) return null

  return (
    <TooltipStyled title={title} placement="top" arrow {...otherProps}>
      <TooltipIcon>
        <InfoIcon sx={{ color: "#BFD8FF" }} />
      </TooltipIcon>
    </TooltipStyled>
  )

}

export default Tooltip